import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { withArtDirection } from "gatsby-plugin-image";
import { BREAKPOINTS } from "@utils/breakpoints";
import { isObject } from "@utils/typecheck";

const getResponsiveImageData = (images, breakpoints) => {
  const isValidBreakpoint = ([breakpoint]) => breakpoint in breakpoints;
  const isValidImage = ([, image]) => Boolean(getImage(image));
  const getMediaQuery = (breakpoint) => `(max-width: ${breakpoints[breakpoint]}px)`;

  return Object.entries(images)
    .filter(isValidBreakpoint)
    .filter(isValidImage)
    .map(([breakpoint, imageData]) => ({
      media: getMediaQuery(breakpoint),
      image: getImage(imageData),
    }));
};

const ResponsiveImage = ({
  className,
  images,
  alt = "",
  breakpoints = BREAKPOINTS,
  defaultImageBreakpoint = "xxl",
}) => {
  if (!isObject(images)) {
    console.warn("Invalid images object provided");
    return null;
  }

  // Check that there is at least one valid responsive image
  const responsiveImages = getResponsiveImageData(images, breakpoints);
  if (responsiveImages.length === 0) {
    console.warn("No valid image found for any breakpoint.\n images:", images, "\nbreakpoints:", breakpoints);
    return null;
  }

  // Check that there is a valid default image
  const defaultImage = getImage(images[defaultImageBreakpoint]);
  if (!defaultImage) {
    console.warn(`No valid image found for defaultImageBreakpoint: ${defaultImageBreakpoint}`);
    return null;
  }

  const artDirectedImage = withArtDirection(defaultImage, responsiveImages);

  return <GatsbyImage className={className} alt={alt} image={artDirectedImage} />;
};

export { ResponsiveImage };
